import React, {useState} from 'react';
import {MinusOutlined, PlusOutlined} from '@ant-design/icons';

import styles from './use-counter.module.css';
import {Button} from '../button/button';

export const useCounter = (defaultValue = 1) => {
    const [count, setCount] = useState(defaultValue);

    return useControlledCounter(
        count,
        () => setCount(count + 1),
        () => setCount(count > 1 ? count - 1 : 1),
    );
};

export const useControlledCounter = (count = 1, incrementCount: () => void, decrementCount: () => void) => {
    const handleIncrement = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();

        incrementCount();
    };

    const handleDecrement = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();

        decrementCount();
    };

    return {
        count,
        component: (
            <div className={styles.counter}>
                <Button onClick={handleDecrement} type={'ghost'}>
                    <MinusOutlined style={{fontSize: '20px'}} />
                </Button>
                <span>{count}</span>
                <Button onClick={handleIncrement} type={'ghost'}>
                    <PlusOutlined style={{fontSize: '20px'}} />
                </Button>
            </div>
        ),
    };
};
